<div class="thumbnail-loader-container white">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40">
        <polygon points="12.06 17.32 9.96 17.32 9.96 4.98 29.78 4.98 29.78 17.2 27.68 17.2 27.68 7.08 12.06 7.08 12.06 17.32" style="fill:#f1f0f0"/>
        <polygon points="44.13 28.92 24.64 28.92 24.64 26.82 40.5 26.82 32.45 12.89 25.72 24.55 23.91 23.5 32.45 8.7 44.13 28.92" style="fill:#f1f0f0"/>
        <path d="M15.78,35a9.91,9.91,0,1,1,9.91-9.91A9.92,9.92,0,0,1,15.78,35Zm0-17.72a7.82,7.82,0,1,0,7.82,7.81A7.81,7.81,0,0,0,15.78,17.3Z" style="fill:#f1f0f0"/>
    </svg>
</div>